fx.ns("desktop.poster", class PosterView extends shared.stage.BaseView{

    constructor(board)
    {
        super(board);

        this.vmargin = 120;
        
    }

    update(animate) 
    {    
        super.update(animate);

        if (!this.board.currentArea)
            return;

        let screenWidth = (this.board.realWidth - 125); // 125 == topbar | TODO : get TopBar reference
        let screenHeight = this.board.realHeight - this.vmargin;
        let screenWidthMax = screenWidth * 0.9;
        let screenHeightMax = screenHeight * 0.90;

        let yPos = this.vmargin;

        let childScale;
        let ratio = this.board.currentArea.height() / this.board.currentArea.width();
        
        if (screenWidthMax * ratio < screenHeightMax)
            childScale = screenWidthMax / this.board.currentArea.width();
        else
            childScale = screenHeightMax / this.board.currentArea.height();
        
        this.board.currentArea.show();
        this.board.currentArea.load();
        
        this.applyPosition(this.board.currentArea, { scale : childScale,
                                    x : (screenWidth - this.board.currentArea.realWidth*childScale)/2 / childScale,
                                    y :  yPos / childScale }, animate);

        this.board.currentArea.removeClass("movable");

    }

   
});
